var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'plant-points': true,
        'default-background': _vm.background === 'green',
        'alt-background': _vm.background === 'white',
    }},[_c('img',{staticClass:"image",attrs:{"src":_vm.image.src,"alt":_vm.image.alt,"width":_vm.image.width,"height":_vm.image.height}}),_vm._v(" "),_c('div',[_c('h3',{staticClass:"title"},[_vm._v("plant points")]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }